export const MANAGE_RULE = 'Manage Rule';
export const SAVE = 'Save';
export const ENABLE_MATCH_RULE = 'Enable Match Rule';
export const RULE_DESCRIPTION =
  'Enabling this rule allows customers to match again only after time limit';
export const ENABLE_NFC_TICKET_OUT = 'Enable NFC Ticket Out';
export const NFC_TICKET_OUT_DESCRIPTION =
  'When enabled, employees with NFC access can scan a machine to auto-fill the Ticket Out form. Turn this off to require manual machine entry.';
export const ENABLE_AUDIT_VERIFICATION =
  'Enable Audit Verification of Bonuses & Raffles';
export const AUDIT_VERIFICATION_DESCRIPTION =
  'When enabled, a reading session cannot be closed until every bonus and raffle in that session has been audited (approved or flagged).';
export const ENABLE_TICKET_PHOTO = 'Enable Ticket Photo Requirement';
export const TICKET_PHOTO_DESCRIPTION =
  'When an employee enters a Ticket Out at or above the minimum amount, the system will require them to take a photo before saving.';
export const ENABLE_VIP_MATCH = 'Enable VIP Match';
export const VIP_MATCH_DESCRIPTION =
  "When a pending customer's points are at or above the minimum amount, the employee must take a photo before the machine can be set on the Dashboard.";
export const REQUIRE_PHONE_VERIFICATION = 'Require Phone Verification';
export const PHONE_VERIFICATION_DESCRIPTION =
  "When enabled, customers must verify their phone with an SMS code before enrolling on the tablet or being registered on the Add-Customer form. Turn this off for locations that don't need phone verification.";
export const ENABLE_NUVE_BOOST = 'Enable NuVe Boost';
export const NUVE_BOOST_DESCRIPTION =
  'When enabled, the NuVe Boost (SMS/MMS marketing) menu is available to permitted staff at this location. Turn this off to hide NuVe Boost here — the menu updates right after you save, no re-login needed.';

export const VIP_MATCH_POINT_PRESETS = [30, 40, 50, 100, 200];
export const DEFAULT_VIP_MATCH_POINTS = 40;
